import styled from 'styled-components';
import { media } from 'src/assets/_responsive-mixin';

export const PageContainer = styled.section`
  position: relative;
  height: 100%;
  min-height: calc(100vh - var(--header-height));
  width: calc(100% - var(--sidebar-width));
  padding: 16px 128px 128px;
  margin: 0 auto;
  margin-top: var(--header-height);
  margin-left: var(--sidebar-width);
  background: var(--content-background);

  ${media.xlarge`
    padding: 16px 64px 128px;
	`}

  ${media.large`
    padding: 16px 64px 64px;
	`}

  ${media.small`
    margin-left: 0;
    width: 100%;
    padding: 16px;
	`}
`;
